import { render, staticRenderFns } from "./KimsaPagination.vue?vue&type=template&id=c36bab20&scoped=true"
import script from "./KimsaPagination.vue?vue&type=script&lang=js"
export * from "./KimsaPagination.vue?vue&type=script&lang=js"
import style0 from "./KimsaPagination.vue?vue&type=style&index=0&id=c36bab20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36bab20",
  null
  
)

export default component.exports